module.exports = __webpack_public_path__ + "img/msteam-addin-03.7d4e3179.png";